module.exports = __webpack_public_path__ + "static/Grupo 128-41a7a231e25dbe45c09d96cce27c006c.png";